import { useEffect, useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Box from '@mui/material/Box';

import menuIcon from 'assets/header/menu-icon.webp';
import closeIcon from 'assets/header/close-icon.webp';
import logo from 'assets/logo.svg';
import chevron from 'assets/common/icons/chevron-right.svg';

import {
  MobileHeaderContainer,
  MobileNavigation,
  Divider,
  ContactUsButton,
  LogoLink,
  Container,
  MenuButton,
  HeaderLinkGroupTitle,
  MobileHeaderLink,
  MobileHeaderTopLevelLink,
  MobileNavigationOuter,
  MobileHeaderLinkWrapper,
} from './MobileHeader.style';
import { homeMeta, resourcesMeta } from 'constants/pages';
import {
  applicationsItems,
  customerCasesItems,
  industriesItems,
  platformItems,
  actionPacksItems,
} from './constants';
import { colors, theme } from 'styles';
import { NavAccordionKey } from 'components/Footer/Footer';
import { useMediaQuery } from '@mui/material';
import { Accordion } from 'components/Accordion/Accordion';

type MobileHeaderProps = {
  openModal: () => void;
};

export const MobileHeader = ({ openModal }: MobileHeaderProps) => {
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [openKeys, setOpenKeys] = useState<NavAccordionKey[]>([]);

  const handleToggle = (key: NavAccordionKey) => {
    setOpenKeys((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]));
  };

  const onClick = () => {
    setIsOpen((value: boolean) => !value);
  };

  const closeMenu = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    return () => {
      setIsOpen(false);
    };
  }, []);

  return (
    <>
      <Box
        height={{
          md: '60px',
          xxs: '82px',
        }}
      />
      <ClickAwayListener onClickAway={closeMenu}>
        <MobileHeaderContainer component="header" sx={{ height: isOpen ? '100vh' : undefined }}>
          <Container isNavOpen={isOpen}>
            <LogoLink to={homeMeta.url}>
              <img src={logo} alt="logo icon" />
            </LogoLink>
            <MenuButton size="medium" onClick={onClick}>
              <img alt="header-menu-toggle" src={isOpen ? closeIcon : menuIcon} loading="lazy" />
            </MenuButton>
          </Container>
          {isOpen && (
            <MobileNavigationOuter>
              <MobileNavigation component="nav">
                <Accordion
                  trigger={
                    <HeaderLinkGroupTitle
                      isOpen={openKeys.includes(NavAccordionKey.ActionPacks)}
                      variant="h3"
                    >
                      Get Started! <img src={chevron} alt="Chevron icon" />
                    </HeaderLinkGroupTitle>
                  }
                  isDesktop={isDesktop}
                  isOpen={openKeys.includes(NavAccordionKey.ActionPacks)}
                  onToggle={() => handleToggle(NavAccordionKey.ActionPacks)}
                >
                  <MobileHeaderLinkWrapper>
                    {actionPacksItems.map((item) => (
                      <MobileHeaderLink key={item.name} onClick={closeMenu} to={item.to}>
                        {item.name}
                      </MobileHeaderLink>
                    ))}
                  </MobileHeaderLinkWrapper>
                </Accordion>

                <Divider />

                <Accordion
                  trigger={
                    <HeaderLinkGroupTitle
                      isOpen={openKeys.includes(NavAccordionKey.Platform)}
                      variant="h3"
                    >
                      Platform <img src={chevron} alt="Chevron icon" />
                    </HeaderLinkGroupTitle>
                  }
                  isDesktop={isDesktop}
                  isOpen={openKeys.includes(NavAccordionKey.Platform)}
                  onToggle={() => handleToggle(NavAccordionKey.Platform)}
                >
                  <MobileHeaderLinkWrapper>
                    {platformItems.map((item) => (
                      <MobileHeaderLink key={item.name} onClick={closeMenu} to={item.to}>
                        {item.name}
                      </MobileHeaderLink>
                    ))}
                  </MobileHeaderLinkWrapper>
                </Accordion>

                <Divider />

                <Accordion
                  trigger={
                    <HeaderLinkGroupTitle
                      isOpen={openKeys.includes(NavAccordionKey.Industries)}
                      variant="h3"
                    >
                      Industries <img src={chevron} alt="Chevron icon" />
                    </HeaderLinkGroupTitle>
                  }
                  isDesktop={isDesktop}
                  isOpen={openKeys.includes(NavAccordionKey.Industries)}
                  onToggle={() => handleToggle(NavAccordionKey.Industries)}
                >
                  <MobileHeaderLinkWrapper>
                    {industriesItems.map((industry) => (
                      <MobileHeaderLink key={industry.name} onClick={closeMenu} to={industry.to}>
                        {industry.name}
                      </MobileHeaderLink>
                    ))}
                  </MobileHeaderLinkWrapper>
                </Accordion>

                <Divider />

                <Accordion
                  trigger={
                    <HeaderLinkGroupTitle
                      isOpen={openKeys.includes(NavAccordionKey.Applications)}
                      variant="h3"
                    >
                      Applications <img src={chevron} alt="Chevron icon" />
                    </HeaderLinkGroupTitle>
                  }
                  isDesktop={isDesktop}
                  isOpen={openKeys.includes(NavAccordionKey.Applications)}
                  onToggle={() => handleToggle(NavAccordionKey.Applications)}
                >
                  <MobileHeaderLinkWrapper>
                    {applicationsItems.map((item) => (
                      <MobileHeaderLink key={item.name} onClick={closeMenu} to={item.to}>
                        {item.name}
                      </MobileHeaderLink>
                    ))}
                  </MobileHeaderLinkWrapper>
                </Accordion>

                <Divider />

                <Accordion
                  trigger={
                    <HeaderLinkGroupTitle
                      isOpen={openKeys.includes(NavAccordionKey.Customer_case)}
                      variant="h3"
                    >
                      Customer Cases <img src={chevron} alt="Chevron icon" />
                    </HeaderLinkGroupTitle>
                  }
                  isDesktop={isDesktop}
                  isOpen={openKeys.includes(NavAccordionKey.Customer_case)}
                  onToggle={() => handleToggle(NavAccordionKey.Customer_case)}
                >
                  <MobileHeaderLinkWrapper>
                    {customerCasesItems.map((cutomerCase) => (
                      <MobileHeaderLink
                        key={cutomerCase.name}
                        onClick={closeMenu}
                        to={cutomerCase.to}
                      >
                        {cutomerCase.name}
                      </MobileHeaderLink>
                    ))}
                  </MobileHeaderLinkWrapper>
                </Accordion>

                <Divider />

                {/* <Accordion
                  trigger={
                    <HeaderLinkGroupTitle
                      isOpen={openKeys.includes(NavAccordionKey.Company)}
                      variant="h3"
                    >
                      Company <img src={chevron} alt="Chevron icon" />
                    </HeaderLinkGroupTitle>
                  }
                  isDesktop={isDesktop}
                  isOpen={openKeys.includes(NavAccordionKey.Company)}
                  onToggle={() => handleToggle(NavAccordionKey.Company)}
                >
                  <MobileHeaderLinkWrapper>
                    <MobileHeaderLink onClick={closeMenu} to={aboutMeta.url}>
                      About us
                    </MobileHeaderLink>

                    <MobileHeaderLink onClick={closeMenu} to={careersMeta.url}>
                      Careers
                    </MobileHeaderLink>
                  </MobileHeaderLinkWrapper>
                </Accordion>

                <Divider /> */}

                <MobileHeaderTopLevelLink onClick={closeMenu} to={resourcesMeta.url}>
                  Resources
                </MobileHeaderTopLevelLink>

                <Box
                  sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: '100%',
                    padding: '16px',
                    background: colors.white,
                  }}
                >
                  <ContactUsButton
                    onClick={openModal}
                    color="secondary"
                    variant="contained"
                    sx={{
                      width: '100%',
                      maxWidth: '343px',
                      fontSize: '16px',
                      margin: '0 auto',
                      display: 'block',
                    }}
                  >
                    Contact us
                  </ContactUsButton>
                </Box>
              </MobileNavigation>
            </MobileNavigationOuter>
          )}
        </MobileHeaderContainer>
      </ClickAwayListener>
    </>
  );
};
